import React from 'react';
export function ButtonMaxWidthElement(props) {
    var children = props.children, maxWidth = props.maxWidth;
    if (!maxWidth) {
        return children;
    }
    return React.createElement("div", { style: { maxWidth: maxWidth } }, children);
}
//# sourceMappingURL=button-max-width-element.js.map